import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import CustomSingleSelect, { CustomSingleSelectModel } from '../../../../components/CustomSingleSelect';
import { storeActivityIndicator, storeAreYouSureModalCallback } from '../../../../redux/reducers/authSlice';
import { ConstantService } from '../../../../services/ConstantService';
import { KTCard } from '../../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../../_metronic/helpers/components/KTCardBody';
import toast from "react-hot-toast";
import { Helpers } from '../../../../helpers/Helpers';
import { GetCompanyByIdResponseCompanyAddress } from '../../../../models/response/company/GetCompanyByIdResponse';
import Box from '../../../../components/Box';
import CustomSwitch from '../../../../components/CustomSwitch';
import { GetCompanyAddressByCountryIdAndPostalCodeResponse } from '../../../../models/response/companyAddress/GetCompanyAddressByCountryIdAndPostalCodeResponse';
import { CompanyAddressService } from '../../../../services/CompanyAddressService';
import { CompanyAddressTypeEnum } from '../../../../models/common/Enums';
import { GetConstantListResponse } from '../../../../models/response/constant/GetConstantListResponse';
import { CountryService } from '../../../../services/CountryService';

interface Props {
    addressInformationRef: any
    companyAddresses: GetCompanyByIdResponseCompanyAddress[]
    setCompanyAddresses: React.Dispatch<React.SetStateAction<GetCompanyByIdResponseCompanyAddress[]>>
    canBeEdited: boolean
}

const AddressInformation = ({
    addressInformationRef,
    companyAddresses,
    setCompanyAddresses,
    canBeEdited
}: Props) => {
    const dispatch = useDispatch();
    const [companyAddressId, setCompanyAddressId] = useState('');
    const [selectedAddressType, setSelectedAddressType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedCountry, setSelectedCountry] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedCounty, setSelectedCounty] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedDistrict, setSelectedDistrict] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedNeighborhood, setSelectedNeighborhood] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [addressText, setAddressText] = useState<string | undefined>(undefined);
    const [postalCode, setPostalCode] = useState<string | undefined>(undefined);
    const [isAddressActive, setIsAddressActive] = useState(true);
    const [isDefaultAddress, setIsDefaultAddress] = useState(false);
    const [isOpen, setIsOpen] = useState(false);

    const saveItem = async () => {
        try {
            dispatch(storeActivityIndicator(true));

            var response: GetConstantListResponse = await ConstantService.getConstantList('COMPANY_ADDRESS_TYPE', undefined, CompanyAddressTypeEnum.FATURA_ADRESI);

            if (!response.isSuccess) {
                toast.error(response.message);
                return;
            }

            var foundAddress = companyAddresses.find(x => x.addressTypeId == response.data[0].constantId && selectedAddressType?.value == response.data[0].constantId && x.companyAddressId != companyAddressId);

            if (foundAddress) {
                toast.error("Yanlızca bir adet fatura adresi eklenebilir!");
                return;
            }

            if (Helpers.isEmpty(companyAddressId)) {
                var o: GetCompanyByIdResponseCompanyAddress = {
                    addressText: addressText,
                    addressTypeId: selectedAddressType?.value,
                    addressTypeName: selectedAddressType?.label,
                    countryId: selectedCountry?.value,
                    countryName: selectedCountry?.label,
                    countyId: selectedCounty?.value,
                    countyName: selectedCounty?.label,
                    districtId: selectedDistrict?.value,
                    districtName: selectedDistrict?.label,
                    isCustomActive: isAddressActive,
                    isDefault: isDefaultAddress,
                    companyAddressId: Helpers.generateUUID(),
                    postalCode: postalCode,
                    isSelected: false,
                    neighborhoodId: selectedNeighborhood?.value,
                    neighborhoodName: selectedNeighborhood?.label,
                }

                setCompanyAddresses([...companyAddresses, o])
            }
            else {
                setCompanyAddresses(companyAddresses.map(function (x) {
                    if (x.companyAddressId == companyAddressId) {
                        x.addressText = addressText;
                        x.addressTypeId = selectedAddressType?.value;
                        x.addressTypeName = selectedAddressType?.label;
                        x.countryId = selectedCountry?.value;
                        x.countryName = selectedCountry?.label;
                        x.countyId = selectedCounty?.value;
                        x.countyName = selectedCounty?.label;
                        x.districtId = selectedDistrict?.value;
                        x.districtName = selectedDistrict?.label;
                        x.isCustomActive = isAddressActive;
                        x.isDefault = isDefaultAddress;
                        x.postalCode = postalCode;
                        x.isSelected = false;
                        x.neighborhoodId = selectedNeighborhood?.value;
                        x.neighborhoodName = selectedNeighborhood?.label;
                    }

                    return x;
                }))
            }

            setCompanyAddressId('');
            setSelectedAddressType(undefined);
            setSelectedCountry(undefined);
            setSelectedCounty(undefined);
            setAddressText('');
            setPostalCode('');
            setSelectedDistrict(undefined);
            setIsAddressActive(true);
            setIsDefaultAddress(false);
            setSelectedNeighborhood(undefined);
            setIsOpen(false);
            scrollTo();
        } catch (error: any) {
            toast.error(error);
        }
        finally {
            dispatch(storeActivityIndicator(false));
        }
    }

    const setUpdateItem = () => {
        var o = companyAddresses.filter(x => x.isSelected)[0];

        setCompanyAddressId(o.companyAddressId);

        if (o.addressTypeId)
            setSelectedAddressType({ label: o.addressTypeName + '', value: o.addressTypeId });

        if (o.countyId) {
            setSelectedCounty({ label: o.countyName + '', value: o.countyId });
        }

        if (o.countryId) {
            setSelectedCountry({ label: o.countryName + '', value: o.countryId });
        }

        if (o.districtId)
            setSelectedDistrict({ label: o.districtName + '', value: o.districtId });

        if (o.neighborhoodId)
            setSelectedNeighborhood({ label: o.neighborhoodName + '', value: o.neighborhoodId });

        setPostalCode(o.postalCode);
        setAddressText(o.addressText);
        setIsAddressActive(o.isCustomActive);
        setIsDefaultAddress(o.isDefault);
        setIsOpen(true);
        scrollTo();
    }

    const cancelAdding = async () => {
        try {
            if (!isOpen) {
                if (companyAddresses.length == 0) {
                    dispatch(storeActivityIndicator(true));

                    var response: GetConstantListResponse = await ConstantService.getConstantList('COMPANY_ADDRESS_TYPE', undefined, CompanyAddressTypeEnum.FATURA_ADRESI);

                    if (!response.isSuccess) {
                        toast.error(response.message);
                        return;
                    }


                    setIsDefaultAddress(true);
                    setSelectedAddressType({ label: response.data[0].value, value: response.data[0].constantId })
                }

                setIsOpen(true);
                scrollTo();
                return;
            }

            setCompanyAddressId('');
            setSelectedAddressType(undefined);
            setSelectedCountry(undefined);
            setSelectedCounty(undefined);
            setAddressText('');
            setPostalCode('');
            setSelectedDistrict(undefined);
            setIsAddressActive(true);
            setIsDefaultAddress(false);
            setSelectedNeighborhood(undefined);
            setIsOpen(false);
            scrollTo();
        } catch (error: any) {
            toast.error(error);
        }
        finally {
            dispatch(storeActivityIndicator(false));
        }
    }

    const scrollTo = () => {
        var headerOffset = 120;
        var elementPosition = addressInformationRef.current.getBoundingClientRect().top;
        var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });
    }

    const deleteItems = () => {
        setCompanyAddresses(companyAddresses.filter(x => !x.isSelected));
    }

    const selectAll = () => {
        var isAllSelected = companyAddresses.length == companyAddresses.filter(x => x.isSelected).length;

        setCompanyAddresses(companyAddresses.map(function (x) {
            x.isSelected = !isAllSelected;
            return x;
        }))
    }

    const setItemSelected = (_id: string) => {
        setCompanyAddresses(companyAddresses.map(function (x) {
            if (x.companyAddressId == _id)
                x.isSelected = !x.isSelected;
            return x;
        }))
    }

    const getCompanyAddressByCountryIdAndPostalCode = async (_selectedCountry: CustomSingleSelectModel | undefined, _postalCode: string | undefined) => {
        try {
            if (_selectedCountry && _postalCode && !Helpers.isEmpty(_postalCode)) {
                dispatch(storeActivityIndicator(true));

                var response: GetCompanyAddressByCountryIdAndPostalCodeResponse = await CompanyAddressService.getCompanyAddressByCountryIdAndPostalCode(_selectedCountry.value, _postalCode);

                if (!response.isSuccess) {
                    toast.error(response.message);
                    dispatch(storeActivityIndicator(false));
                    return;
                }

                if (response.data) {
                    if (response.data.countyId && response.data.countyName)
                        setSelectedCounty({ label: response.data.countyName, value: response.data.countyId })

                    if (response.data.districtId && response.data.districtName)
                        setSelectedDistrict({ label: response.data.districtName, value: response.data.districtId })
                }
                else {
                    setSelectedCounty(undefined)
                    setSelectedDistrict(undefined);
                }
            }
        } catch (error: any) {
            toast.error(error);
        }
        finally {
            dispatch(storeActivityIndicator(false));
        }
    }

    return (
        <div className='containerPart' ref={addressInformationRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Adres Bilgileri</h4>

                    {
                        isOpen && (
                            <React.Fragment>
                                <div className='row'>
                                    <div className="col-md-4">
                                        <div>
                                            <label htmlFor="exampleFormControlInput1" className="form-label">Adres Türü</label>

                                            <CustomSingleSelect
                                                selectedValue={selectedAddressType}
                                                onChange={setSelectedAddressType}
                                                insertable={{
                                                    onSubmit: { code: 'COMPANY_ADDRESS_TYPE' }
                                                }}
                                                onMenuOpen={() => ConstantService.getConstantList('COMPANY_ADDRESS_TYPE')}
                                                labelName='value'
                                                valueName='constantId'
                                            />
                                        </div>

                                        <div className="mt-5">
                                            <label htmlFor="exampleFormControlInput1" className="form-label">Açık Adres</label>
                                            <textarea value={addressText} onChange={(e) => setAddressText(e.target.value)} style={{ border: '1px solid #F1F1F4', width: '100%', height: 100, resize: 'none' }} className="form-control form-control-solid" />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div>
                                            <label htmlFor="exampleFormControlInput1" className="form-label">Ülke</label>

                                            <CustomSingleSelect
                                                selectedValue={selectedCountry}
                                                onChange={(selectedItem) => {
                                                    setSelectedCountry(selectedItem);
                                                    setSelectedCounty(undefined);
                                                    setSelectedDistrict(undefined);
                                                    setSelectedNeighborhood(undefined);
                                                    getCompanyAddressByCountryIdAndPostalCode(selectedItem, postalCode);
                                                }}
                                                onMenuOpen={() => CountryService.getCountryList()}
                                                labelName='name'
                                                valueName='countryId'
                                            />
                                        </div>

                                        <div className="mt-5">
                                            <label htmlFor="exampleFormControlInput1" className="form-label">Posta Kodu</label>
                                            <input onBlur={() => getCompanyAddressByCountryIdAndPostalCode(selectedCountry, postalCode)} value={postalCode} onChange={(e) => setPostalCode(e.target.value)} style={{ border: '1px solid #F1F1F4' }} type={'text'} className="form-control form-control-solid" />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div>
                                            <label htmlFor="exampleFormControlInput1" className="form-label">Şehir</label>

                                            <CustomSingleSelect
                                                selectedValue={selectedCounty}
                                                onChange={(selectedItem) => {
                                                    setSelectedCounty(selectedItem);
                                                    setSelectedDistrict(undefined);
                                                    setSelectedNeighborhood(undefined);
                                                }}
                                                onMenuOpen={selectedCountry ? () => ConstantService.getConstantList('COUNTY', selectedCountry.value) : undefined}
                                                labelName='value'
                                                valueName='constantId'
                                            />
                                        </div>

                                        <div className="mt-5">
                                            <label htmlFor="exampleFormControlInput1" className="form-label">İlçe</label>

                                            <CustomSingleSelect
                                                selectedValue={selectedDistrict}
                                                onChange={(selectedItem) => {
                                                    setSelectedDistrict(selectedItem);
                                                    setSelectedNeighborhood(undefined);
                                                }}
                                                onMenuOpen={selectedCounty ? () => ConstantService.getConstantList('DISTRICT', selectedCounty.value) : undefined}
                                                labelName='value'
                                                valueName='constantId'
                                            />
                                        </div>

                                        <div className='mt-5'>
                                            <CustomSingleSelect
                                                labelText="Semt"
                                                selectedValue={selectedNeighborhood}
                                                onChange={setSelectedNeighborhood}
                                                onMenuOpen={selectedDistrict ? () => ConstantService.getConstantList('NEIGHBORHOOD', selectedDistrict.value) : undefined}
                                                labelName='value'
                                                valueName='constantId'
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Aktif</label>

                                        <CustomSwitch isActive={isAddressActive} setIsActive={setIsAddressActive} />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Varsayılan</label>

                                        <CustomSwitch disabled={companyAddresses.filter(x => x.companyAddressId != companyAddressId && x.isDefault).length > 0} isActive={isDefaultAddress} setIsActive={setIsDefaultAddress} />
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-12">
                                        <Box alignItems="flex-end">
                                            <Box onClick={saveItem} className="actionIcon p-2 bg-success" justifyContent="center" flexDirection="row" borderRadius="4px">
                                                <Box mr="5px" justifyContent="center">
                                                    <i className="text-white fa fa-check" />
                                                </Box>
                                                <Box justifyContent="center">
                                                    <span style={{ fontWeight: 600 }} className="text-white">Kaydet</span>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </div>
                                </div>

                                <Box className='ebbe-hr m-0 mt-5'>&nbsp;</Box>
                            </React.Fragment>
                        )
                    }

                    <Box className={isOpen ? "mt-5" : ""} flexDirection="row">
                        <Box onClick={!canBeEdited ? undefined : cancelAdding} className={"actionIcon p-2 " + (!isOpen ? "bg-success" : "")} bg={isOpen ? 'orange' : undefined} opacity={!canBeEdited ? "0.5" : "1"} justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className={"text-white fa " + (!isOpen ? 'fa-plus' : 'fa-times')} />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">{!isOpen ? 'Ekle' : 'İptal Et'}</span>
                            </Box>
                        </Box>

                        <Box onClick={!canBeEdited ? undefined : companyAddresses.filter(x => x.isSelected).length == 1 ? setUpdateItem : undefined} opacity={!canBeEdited ? "0.5" : companyAddresses.filter(x => x.isSelected).length == 1 ? "1" : "0.5"} ml="10px" className="actionIcon p-2 bg-primary" justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className="text-white fa fa-edit" />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">Güncelle</span>
                            </Box>
                        </Box>


                        <Box onClick={!canBeEdited ? undefined : companyAddresses.filter(x => x.isSelected).length > 0 ? () => dispatch(storeAreYouSureModalCallback(deleteItems)) : undefined} opacity={!canBeEdited ? "0.5" : companyAddresses.filter(x => x.isSelected).length > 0 ? "1" : "0.5"} ml="10px" className="actionIcon p-2 bg-danger" justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className="text-white fa fa-trash" />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">Sil</span>
                            </Box>
                        </Box>
                    </Box>

                    <div className="row mt-5">
                        <div className="col-md-12">
                            <div className='table-responsive'>
                                <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer'>
                                    <thead>
                                        <tr className='text-start text-muted fw-bolder text-uppercase'>
                                            <th style={{ width: 1 }}>
                                                <div className='d-flex'>
                                                    <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                        <input disabled={!canBeEdited} onChange={selectAll} className='form-check-input' type='checkbox' checked={companyAddresses.filter(x => x.isSelected).length > 0 && companyAddresses.filter(x => x.isSelected).length == companyAddresses.length} />
                                                    </label>
                                                </div>
                                            </th>
                                            <th>Adres Türü</th>
                                            <th>Açık Adres</th>
                                            <th>Ülke</th>
                                            <th>Şehir</th>
                                            <th>İlçe</th>
                                            <th>Semt</th>
                                            <th>Varsayılan</th>
                                            <th>Durum</th>
                                            <th>Posta Kodu</th>
                                        </tr>
                                    </thead>
                                    <tbody className='text-gray-600 fw-bold'>
                                        {
                                            companyAddresses.length == 0 && (
                                                <tr>
                                                    <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                                </tr>
                                            )
                                        }
                                        {
                                            companyAddresses.map((item, index) =>
                                                <tr>
                                                    <td style={{ width: 1 }}>
                                                        <div className='d-flex'>
                                                            <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                                <input disabled={!canBeEdited} onChange={() => setItemSelected(item.companyAddressId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                            </label>
                                                        </div>
                                                    </td>
                                                    <td>{item.addressTypeName}</td>
                                                    <td>{item.addressText}</td>
                                                    <td>{item.countryName}</td>
                                                    <td>{item.countyName}</td>
                                                    <td>{item.districtName}</td>
                                                    <td>{item.neighborhoodName}</td>
                                                    <td>{item.isDefault ? <i style={{ fontSize: 20 }} className="text-success fa fa-check-circle" /> : <i style={{ fontSize: 20 }} className="text-danger fa fa-times-circle" />}</td>
                                                    <td>{item.isCustomActive ? <i style={{ fontSize: 20 }} className="text-success fa fa-check-circle" /> : <i style={{ fontSize: 20 }} className="text-danger fa fa-times-circle" />}</td>
                                                    <td>{item.postalCode}</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default AddressInformation;